import React from 'react';
import { Avatar as MaterialUiAvatar, AvatarProps } from '@mui/material';
import { ISharedProps } from '../../tools/ISharedProps';
import { makeStyles } from '~/UIKit/Style';
import { getInitials } from '~/Helpers/String.helper';
import { classnames } from 'tss-react/tools/classnames';

interface IAvatarProps extends AvatarProps, ISharedProps {
  size?: number;
  name?: string;
  imageUrl?: string;
  className?: string;
}

const useStyles = (size: number) =>
  makeStyles({
    avatarContainer: {
      width: size,
      height: size,
      fontSize: size / 2,
    },
  });

export const Avatar = ({
  size = 30,
  name = 'U U',
  imageUrl,
  className,
  ...props
}: IAvatarProps) => {
  const { classes } = useStyles(size)();
  const [firstName = '', lastName = ''] = name?.split(' ') ?? [];

  const children = props.children ? props.children : getInitials(firstName, lastName);

  return imageUrl ? (
    <MaterialUiAvatar
      className={classnames([classes.avatarContainer, className])}
      src={imageUrl}
      {...props}
    />
  ) : (
    <MaterialUiAvatar className={classnames([classes.avatarContainer, className])} {...props}>
      {children}
    </MaterialUiAvatar>
  );
};
